<script setup lang="ts">
import { AsYouType } from "libphonenumber-js";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  value: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
  },
  placeholder: {
    type: String,
    default: "",
  },
  error: {
    type: Boolean,
  },
  errorMessage: {
    type: String,
    default: "error",
  },
});

const emit = defineEmits(["input"]);

const model = computed({
  get() {
    return props.value;
  },
  set(value) {
    const formatted = new AsYouType("US").input(value);
    emit("input", formatted);
  },
});
</script>

<template>
  <input
    v-model="model"
    :name="name"
    type="tel"
    :placeholder="placeholder"
    :required="required"
    :class="{ error: error }"
  />
  <FormsFieldError v-show="error">{{ errorMessage }}</FormsFieldError>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/forms";

input {
  @include forms.form-input-base;
}
</style>
